// src/pages/History/MedievalHistory/CrusadesGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Middle_Ages_-_Crusades.png';

function HistoryPageCrusadesGo() {
  return (
    <QuizPage
      title="History: The Crusades"
      subTopic="Crusades"
      backgroundImage={historyImage}
      returnPath="/History-Crusades"
    />
  );
}

export default HistoryPageCrusadesGo;   